export const CHROME_EXTENSION_STORE_URL =
    "https://chromewebstore.google.com/detail/elitphone-%E2%80%93-zoho-crm/jfglibdebghcclgemnkicdjleblhhbml";
